// extracted by mini-css-extract-plugin
export const root = "hamburgerButton-modules--root--3_mbf";
export const clearOverlay = "hamburgerButton-modules--clearOverlay--3gW95";
export const clearOverlayStroke = "hamburgerButton-modules--clearOverlayStroke--2mHXT";
export const crossIcon = "hamburgerButton-modules--crossIcon--3Pc9L";